<script setup lang="ts">
import HeaderCitySelectList from '@/components/Header/HeaderCitySelectList.vue'

type Props = {
  cityName: string
  isCitySelectListShow?: boolean
}

const props = defineProps<Props>()

const model = defineModel<boolean>({ default: false })

const { isMobileOrTablet } = useResponsive()

const searchQuery = ref('')

watch(
  () => props.isCitySelectListShow,
  () => (model.value = true),
)
</script>

<template>
  <the-dialog v-model="model" :max-width="1100" fixed :autofocus="false">
    <div data-e2e="city-list" class="city-select-dialog">
      <div class="city-select-dialog__header">
        <div class="city-select-dialog__search">
          <the-input
            v-model="searchQuery"
            autofocus
            hide-details
            placeholder="Начните вводить ваш город"
          />
        </div>

        <div class="city-select-dialog__label">
          <span v-if="isMobileOrTablet">Изменить город</span>
          <span v-else>Выбран:</span>
        </div>

        <div class="city-select-dialog__selected">
          {{ cityName }}
        </div>
      </div>

      <header-city-select-list
        :search-query="searchQuery || ''"
        :is-visible="modelValue"
      />
    </div>
  </the-dialog>
</template>

<style scoped lang="scss">
.city-select-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;

    @include media('<tablet') {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__search {
    width: 400px;
    overflow: hidden;

    @include media('<desktop-mini') {
      width: 332px;
    }

    @include media('<tablet') {
      order: 2;
      width: 100%;
    }
  }

  &__label {
    margin-left: 20px;
    color: var(--ui-text-secondary);

    @include media('<tablet') {
      margin-bottom: 15px;
      margin-left: 0;
      font-size: 16px;
      font-weight: 700;
      color: var(--ui-text-primary);
    }
  }

  &__selected {
    margin-left: 10px;
    font-weight: 600;
    color: var(--ui-text-primary);

    @include media('<tablet') {
      margin-bottom: 24px;
      margin-left: 0;
    }
  }
}
</style>
